import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';
import { useIsSuperAdmin } from '@/api/hooks';
import { AccessRestricted } from '@/components/admin/AccessRestricted';

/**
 * The /hermes pages (pipeline executions, definitions, the dead-letter queue, the builder) are for
 * super admins only. This closes the screens; the data behind them is closed by hermes migration
 * 692, which gives only super admins read access to the pipeline tables.
 */
export const Route = createFileRoute('/hermes')({
  component: HermesLayout,
});

function HermesLayout() {
  const { isSuperAdmin, isLoading } = useIsSuperAdmin();

  if (isLoading) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isSuperAdmin) {
    return (
      <div className="flex min-h-0 flex-1 bg-background">
        <AccessRestricted message="Super admin role required." />
      </div>
    );
  }

  return <Outlet />;
}
